<template>
    <el-dialog :title="modalTitle" :visible="value" width="90%" @close="$emit('input', false)">
        <el-form :model="form">
            <el-form-item class="mb-8" label="Name*">
                <el-input v-model="form.name" autocomplete="off" required />
            </el-form-item>
            <el-form-item class="mb-8" label="Straße & Hausnummer*">
                <el-input v-model="form.street" autocomplete="off" required />
            </el-form-item>
            <el-form-item class="mb-8" label="PLZ*">
                <el-input v-model="form.zip" autocomplete="off" required />
            </el-form-item>
            <el-form-item class="mb-16" label="Stadt*">
                <el-input v-model="form.city" autocomplete="off" required />
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer u-flex u-flex--space-between">
            <el-button class="u-full-width" type="default" icon="el-icon-close" @click="$emit('input', false)">Abbruch</el-button>
            <el-button
                class="u-full-width"
                type="primary"
                icon="el-icon-check"
                :disabled="!isFormValid"
                :loading="isLoading"
                @click="onSubmit"
            >Speichern</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Appwrite from '@/assets/appwrite'

export default {
    props: {
        value: { type: Boolean, required: true },
        formData: { type: Object, default: null },
    },

    data () {
        return {
            form: this.getEmptyForm(),
            isLoading: false,
        }
    },

    computed: {
        isFormValid () {
            return this.form.name && this.form.street && this.form.zip && this.form.city
        },

        modalTitle () {
            return this.isEditMode ? 'Adresse bearbeiten' : 'Adresse hinzufügen'
        },

        isEditMode () {
            return this.formData !== null
        },
    },

    watch: {
        formData () {
            this.form.name = this.formData?.name || ''
            this.form.street = this.formData?.street || ''
            this.form.zip = this.formData?.zip || ''
            this.form.city = this.formData?.city || ''
        },
    },

    methods: {
        getEmptyForm () {
            return {
                name: '',
                street: '',
                zip: '',
                city: '',
            }
        },

        async onSubmit () {
            if (!this.isFormValid) return

            this.isLoading = true

            try {
                if (this.isEditMode) {
                    await Appwrite.databases.updateDocument(
                        Appwrite.DB_NAME,
                        'address',
                        this.formData.id,
                        this.form,
                    )
                } else {
                    const id = Appwrite.ID.unique()
                    await Appwrite.databases.createDocument(Appwrite.DB_NAME, 'address', id, this.form)
                }

                this.isLoading = false
                this.form = this.getEmptyForm()

                this.$emit('input', false)
                this.$emit('reload')

                this.$notify({
                    title: 'Nice!',
                    message: 'Die Adresse wurde gespeichert',
                    type: 'success',
                })
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
                this.isLoading = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    padding-top: $spacing-unit-16;
    padding-bottom: 0;
}
</style>
